module.exports = __webpack_public_path__ + "static/img/qnbg1.8f90d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnbg1.png
// module id = 354
// module chunks = 0